export default __webpack_public_path__ + "static/time-management-5cc177fec240a33325f8d88cd926065a.png";